/* @ngInject */

export default ($q, $rootScope) => {
  /**
       * Integrations Config
       *
       * @param owner
       * @returns {Array<{
          integration: string
          types: string[],
          enabled: boolean
        }>}
       */
  const integrationsConfig = (owner) => [
    {
      integration: 'VERO',
      types: ['landlord_protection', 'home_and_contents', 'comprehensive_car_insurance'],
      enabled: $rootScope.hasVeroEnabled() && owner?.isVeroEnabled()
    },
    {
      integration: 'ALI',
      types: ['mortgage_protection_insurance', 'risk_insurance'],
      enabled: owner?.isAliEnabled()
    },
    {
      integration: 'MY_CONNECT',
      types: ['utility_connection_service'],
      enabled: owner?.isMyConnectEnabled()
    },
    {
      integration: 'MOVING_HUB',
      types: ['utility_connection_service'],
      enabled: owner?.isMovingHubEnabled()
    },
    {
      integration: 'LID',
      types: ['risk_insurance'],
      enabled: owner?.isLidEnabled()
    },
    {
      integration: 'COMPARE_CLUB',
      types: ['risk_insurance', 'health_cover'],
      enabled: owner?.isCompareClubEnabled()
    },
    {
      integration: 'SETTLE_EASY',
      types: ['conveyancing_settlement_agency'],
      enabled: owner?.isSettleEasyEnabled()
    },
    {
      integration: 'ALLIANZ',
      types: ['risk_insurance'],
      enabled: owner?.isAllianzEnabled()
    },
    {
      integration: 'CREDIT_FIX_SOLUTION',
      types: ['credit_repair_agency'],
      enabled: owner?.isCreditFixSolutionEnabled()
    },
    {
      integration: 'HONEY',
      types: ['risk_insurance'],
      enabled: owner?.isHoneyEnabled()
    }
  ];
  /**
   * Is Integration Enabled
   *
   * @param owner
   * @param integration
   * @param opportunityType
   * @returns {boolean}
   */
  const isIntegrationEnabled = ({ owner, integration, opportunityType }) => {
    const config = integrationsConfig(owner);

    return config.some(
      (opportunityIntegration) =>
        opportunityIntegration.integration === integration &&
        opportunityIntegration.types.includes(opportunityType) &&
        opportunityIntegration.enabled
    );
  };

  /**
   * Get Available By Type
   *
   * @param owner
   * @param opportunityType
   * @returns {*[]}
   */
  const getAvailableByType = ({ owner, opportunityType }) => {
    const config = integrationsConfig(owner);
    return _.filter(config, (c) => c?.types?.indexOf(opportunityType) > -1 && c?.enabled);
  };

  /**
   * Has Any Integrations Enabled
   *
   * @param owner
   * @param opportunityType
   * @returns {boolean}
   */
  const hasAnyIntegrationsEnabled = ({ owner, opportunityType }) =>
    getAvailableByType({ owner, opportunityType }).length > 0;

  return {
    integrationsConfig,
    isIntegrationEnabled,
    getAvailableByType,
    hasAnyIntegrationsEnabled
  };
};
